import { atom } from "recoil";

// 企業Idが１の本社固定
export const mainCompanyState = atom({
  key: "mainCompanyState",
  default: 1,
});